<template>
    <div id="product-view" class="product-view relative bg-theme-gray w-full flex h-auto ">
        <CategoryList :list="state"></CategoryList>
        <div class="w-[calc(100%-16rem)] h-auto pt-12 pb-40 flex flex-col items-center item-body">
            <section class="w-780 mb-5">
                <p class="text-sm text-txt-lightgray"><router-link class="hover:underline" to="/">HOME</router-link> >
                    <router-link class="hover:underline"
                        :to="{ name: 'Category', query: { operationtype: 'category', webcat_view: category_param } }">{{
                            category_name }}</router-link>
                    > <router-link class="hover:underline"
                        :to="{ name: 'Group', query: { operationtype: 'group', webcat_view: category_param, cassette_id: cassette_block_id } }">{{
                            viewItem.cassette_block_name }}</router-link> > <span class="text-txt-gray">{{ viewItem.product_name
    }}</span>
                </p>
            </section>

            <section class="bg-theme-white w-780">
                <div class="w-full p-5 flex">
                    <div class="w-1/4">
                        <Carousel class="flex">
                            <CarouselSlide v-for="(slide, index) in slides" :key="slide" :index="index"
                                :visibleSlide="visibleSlide">

                                <img :src="slide" class="cursor-pointer" @click="openModal(index)">
                            </CarouselSlide>
                        </Carousel>
                        <!--<Modal :val="postImg" :data="viewItem" v-show="showContent" @close="closeModal" />-->
                        <Modal :flag="imgFlag" v-show="showContent" @close="closeModal" />
                    </div>
                    <div class="w-3/4 pl-4 relative">
                        <SoldOut v-if="viewItem.sold_out_labels == '1'"></SoldOut>
                        <h1 class="text-2xl text-txt-gray pl-4">{{ viewItem.product_name }}</h1>
                        <p class="text-xs text-txt-gray pl-4">メーカー：{{ viewItem.maker_name }}</p>
                        <article class="py-2">
                            <div class="flex">
                                <div class="w-1/2 pl-4">
                                    <p class="text-base text-txt-gray">商品コード：{{ viewItem.ichioshi_product_code }}</p>
                                    <p class="text-base text-txt-gray">品番：{{ viewItem.Product_number }}</p>
                                    <ul class="flex py-2">
                                        <li class="icon_dl">
                                            <img v-if="viewItem.deadline === '３日'" class="w-10 h-10 mr-1"
                                                :src="img_common_path + icon_nouki_3">
                                            <img v-else-if="viewItem.deadline === '電話'" class="w-10 h-10 mr-1"
                                                :src="img_common_path + icon_nouki_tori">
                                            <img v-else class="hidden">
                                        </li>
                                        <li class="icon_dl">

                                            <img v-if="viewItem.deadline_mark == 1" class="w-10 h-10 mr-1"
                                                :src="img_common_path + common_icon_fab03">
                                            <img v-else-if="viewItem.deadline_mark == 2" class="w-10 h-10 mr-1"
                                                :src="img_common_path + common_icon_fab01">
                                            <img v-else-if="viewItem.deadline_mark == 3" class="w-10 h-10 mr-1"
                                                :src="img_common_path + common_icon_fab01">
                                            <img v-else-if="viewItem.deadline_mark == 4" class="w-10 h-10 mr-1"
                                                :src="img_common_path + common_icon_fab02">
                                            <img v-else-if="viewItem.deadline_mark == 5" class="w-10 h-10 mr-1"
                                                :src="img_common_path + common_icon_fab07">
                                            <img v-else class="hidden">
                                        </li>
                                        <li class="icon_green">
                                            <img v-if="viewItem.icon_green === 1" class="w-10 h-10 mr-1"
                                                :src="img_common_path + common_icon_green">
                                            <img v-else class="hidden">
                                        </li>
                                        <li class="icon_gpn">
                                            <img v-if="viewItem.icon_gpn === 1" class="w-10 h-10 mr-1"
                                                :src="img_common_path + common_icon_gpn">
                                            <img v-else class="hidden">
                                        </li>
                                        <li class="icon_eco">
                                            <img v-if="viewItem.icon_eco === 1" class="w-10 h-10 mr-1"
                                                :src="img_common_path + common_icon_ecomark">
                                            <img v-else class="hidden">
                                        </li>
                                    </ul>
                                </div>
                                <div class="w-1/2">
                                    <ul>
                                        <li v-if="viewItem.listprice_maker_off != 0"
                                            class="text-sm font-bold text-txt-gray leading-loose ">
                                            メーカー定価（税抜）￥{{ viewItem.listprice_maker_off }} </li>
                                        <li v-else class="hidden"></li>

                                        <li v-if="viewItem.nomal_off != 0"
                                            class="text-xs text-txt-white bg-theme-red py-1 flex justify-center w-20 my-1">
                                            {{ viewItem.nomal_off }} %OFF！</li>
                                        <li v-else
                                            class="text-xs text-txt-white bg-theme-red py-1 flex justify-center w-20 my-1 hidden">
                                        </li>

                                        <li class="text-xs text-txt-gray font-bold mt-2">価格（税抜）<br><span
                                                class="text-txt-red text-2xl">￥{{ viewItem.price_off }}</span><span
                                                class="text-xs text-txt-gray font-normal">（税込 ￥{{ viewItem.price_on
                                                }}）</span>
                                        </li>
                                        <!--<li class="text-xs text-txt-gray">（税込 ￥{{viewItem.price_on}}）</li>-->
                                    </ul>
                                </div>
                            </div>
                            <p class="text-xs text-txt-red mt-4 pl-4">{{ viewItem.Individual_comment01 }}</p>
                            <p class="text-sm text-txt-red mt-4 pl-4" v-if=viewItem.outlet_stock><span
                                    class="text-txt-red text-2xl">{{ viewItem.outlet_stock }}限り！</span></p>

                        </article>
                    </div>
                </div>
                <div class="w-full p-5 flex">
                    <div class=" flex">
                        <div class="w-1/4">
                            <div class="flex flex-wrap justify-center">
                                <article class="w-16 h-16 m-1">
                                    <img v-if="viewItem.web_img01 === ' ' || viewItem.web_img01 === ''" class="hidden">
                                    <img v-else
                                        class="object-fill w-full h-full border border-bd-gray cursor-pointer hover:border-bd-orange transition uration-300"
                                        v-on:mouseover="mo_img_01" :src="img_path + viewItem.web_img01">
                                </article>
                                <article class="w-16 h-16 m-1">
                                    <img v-if="viewItem.web_img02 === ' ' || viewItem.web_img02 === ''" class="hidden">
                                    <img v-else
                                        class="object-fill w-full h-full border border-bd-gray cursor-pointer hover:border-bd-orange transition uration-300"
                                        v-on:mouseover="mo_img_02" :src="img_path + viewItem.web_img02">
                                </article>
                                <article class="w-16 h-16 m-1">
                                    <img v-if="viewItem.web_img03 === ' ' || viewItem.web_img03 === ''" class="hidden">
                                    <img v-else
                                        class="object-fill w-full h-full border border-bd-gray cursor-pointer hover:border-bd-orange transition uration-300"
                                        v-on:mouseover="mo_img_03" :src="img_path + viewItem.web_img03">
                                </article>
                                <article class="w-16 h-16 m-1">
                                    <img v-if="viewItem.web_img04 === ' ' || viewItem.web_img04 === ''" class="hidden">
                                    <img v-else
                                        class="object-fill w-full h-full border border-bd-gray cursor-pointer hover:border-bd-orange transition uration-300"
                                        v-on:mouseover="mo_img_04" :src="img_path + viewItem.web_img04">
                                </article>
                            </div>
                            <div class="movie_area mt-2">
                                <div class="mov_01 relative h-120">
                                    <iframe v-if="viewItem.movie_url01 === '' || viewItem.movie_url01 === ' '"
                                        class="hidden"></iframe>

                                    <iframe v-else class="w-full h-120 absolute" :src="viewItem.movie_url01" frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                    <div v-if="viewItem.movie_url01 === '' || viewItem.movie_url01 === ' '" class="hidden">

                                    </div>
                                    <div v-else class="w-full h-120 absolute">
                                        <a class="w-full h-120 block" :href="viewItem.movie_url01" target="_blank"></a>
                                    </div>
                                </div>
                                <div class="mov_02 mt-2 relative h-120">
                                    <iframe v-if="viewItem.movie_url02 === '' || viewItem.movie_url02 === ' '"
                                        class="hidden"></iframe>

                                    <iframe v-else class="w-full h-120 absolute" :src="viewItem.movie_url02" frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                    <div v-if="viewItem.movie_url02 === '' || viewItem.movie_url02 === ' '" class="hidden">

                                    </div>
                                    <div v-else class="w-full h-120 absolute">
                                        <a class="w-full h-120 block" :href="viewItem.movie_url02" target="_blank"></a>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w-3/4 pl-8">
                            <div v-if="viewItem.product_catch === ' ' || viewItem.product_catch === ''"
                                class="m-1 p-3 bg-theme-gray hidden">
                                <p class="text-txt-gray text-xs">{{ viewItem.product_catch }}</p>
                            </div>
                            <div v-else class="m-1 p-3 bg-theme-gray">
                                <p class="text-txt-gray text-xs">{{ viewItem.product_catch }}</p>
                            </div>
                            <div class="m-1 mt-3">
                                <h2 class="text-txt-gray text-sm bg-theme-darkgray p-1">商品の詳細</h2>
                                <table>
                                    <tr>
                                        <td class="text-xs text-txt-gray bg-theme-gray w-1/5 p-2 border-bd-gray border-b">
                                            スペック</td>
                                        <td class="text-xs text-txt-gray w-4/5 p-2 border-bd-gray border-b">
                                            {{ viewItem.product_spec }}</td>
                                    </tr>
                                </table>
                            </div>
                            <p class="text-sm text-txt-red m-1 mt-2">{{ viewItem.Individual_comment02 }}</p>

                        </div>
                    </div>
                </div>

                <div class="px-5 mb-5" v-if="state.b_body_arr_len >= 2">
                    <div class="mb-5 table_st" v-for="(b_body, index) in state.b_body_arr" :key=index>
                        <h4 class="font-bold text-base text-txt-black">{{ b_body.key_title }}</h4>

                        <table class="">
                            <thead>
                                <tr class="head text-xs text-txt-gray">
                                    <td class="w-16 px-2"></td>
                                    <td class="w-24 px-2">商品コード</td>
                                    <td class="w-56 px-2">商品名</td>
                                    <td class="w-32 px-2">種別</td>
                                    <td class="w-28 px-2">価格（税抜）</td>
                                    <td class="w-28 px-2">価格（税込）</td>
                                </tr>
                            </thead>

                            <tr class="tr_st" v-for="item in b_body.key_body" :key="item.id">
                                <td class=""><img class="p-1" :src="img_path + item.web_img01"></td>
                                <td class="w-20 px-2 text-sm text-txt-gray relative">
                                    {{ item.ichioshi_product_code }}

                                    <SoldOutRow v-if="item.sold_out_cd === 1"></SoldOutRow>
                                    <!--<SoldOut v-else class="hidden"></SoldOut>-->
                                </td>
                                <td class="w-40 px-2 text-sm text-txt-gray"><router-link class="underline text-txt-link"
                                        @click="handleClick"
                                        :to="{ name: 'Product', query: { operationtype: 'product', webcat_view: item.webcat_view, cassette_id: item.cassette_id, ichioshi_product_code: item.ichioshi_product_code } }">{{
                                            item.product_name }}</router-link></td>
                                <td class="w-28 px-2 text-sm text-txt-gray" v-html="item.kinds"></td>
                                <td class="w-28 px-2 text-sm text-txt-red">¥{{ Number(item.price_off).toLocaleString() }}
                                </td>
                                <td class="w-28 px-2 text-sm text-txt-red">¥{{ Number(item.price_on).toLocaleString() }}
                                </td>
                            </tr>
                        </table>
                    </div>

                </div>
                <!-- グループ商品のやつ -->
                <!--<div class="px-5 mb-5" v-if="state.items && state.items.length >= 2">-->
                <!--    <h4 class="font-bold text-base text-txt-black">{{state.cassette_block_name}}</h4>-->
                <!--    <table>-->
                <!--        <thead>-->
                <!--            <tr class="head text-xs text-txt-gray">-->
                <!--                <td class="w-16 px-2"></td>-->
                <!--                <td class="w-24 px-2">商品コード</td>-->
                <!--                <td class="w-56 px-2">商品名</td>-->
                <!--                <td class="w-32 px-2">種別</td>-->
                <!--                <td class="w-28 px-2">価格（税抜）</td>-->
                <!--                <td class="w-28 px-2">価格（税込）</td>-->
                <!--            </tr>-->
                <!--        </thead>-->
                <!--        <tbody id="bottom_list" class="">-->
                <!--            <tr class="odd:bg-theme-gray even:bg-theme-white" v-for="item in state.items" :key="item.id">-->
                <!--                <td class=""><img class="p-1" :src="img_path + item.web_img01"></td>-->
                <!--                <td class="w-20 px-2 text-sm text-txt-gray relative">-->
                <!--                    <SoldOutRow v-if="state.sold_out_cd === '1'"></SoldOutRow>-->
                <!--                    {{ item.ichioshi_product_code }}-->
                <!--                </td>-->
                <!--                <td class="w-40 px-2 text-sm text-txt-gray"><router-link class="underline text-txt-link" @click="handleClick" :to="{name:'Product',query:{operationtype:'product',webcat_view:item.webcat_view,cassette_id:item.cassette_id,ichioshi_product_code:item.ichioshi_product_code}}">{{ item.product_name }}</router-link></td>-->
                <!--                <td class="w-28 px-2 text-sm text-txt-gray">{{ item.kinds }}</td>-->
                <!--                <td class="w-28 px-2 text-sm text-txt-red">¥{{ Number(item.price_off).toLocaleString() }}</td>-->
                <!--                <td class="w-28 px-2 text-sm text-txt-red">¥{{ Number(item.price_on).toLocaleString() }}</td>-->

                <!--            </tr>-->
                <!--        </tbody>-->
                <!--    </table>-->
                <!--</div>-->

            </section>
            <section class="w-780 mb-10 mt-5">
                <p class="text-sm text-txt-lightgray"><router-link class="hover:underline" to="/">HOME</router-link> >
                    <router-link class="hover:underline"
                        :to="{ name: 'Category', query: { operationtype: 'category', webcat_view: category_param } }">{{
                            category_name }}</router-link>
                    > <router-link class="hover:underline"
                        :to="{ name: 'Group', query: { operationtype: 'group', webcat_view: category_param, cassette_id: cassette_block_id } }">{{
                            viewItem.cassette_block_name }}</router-link> > <span class="text-txt-gray">{{ viewItem.product_name
    }}</span>
                </p>
                <!--<p class="text-sm text-txt-lightgray"><router-link class="hover:underline" to="/">HOME</router-link> > <router-link class="hover:underline" :to="{name:'Category',query:{operationtype:'category',webcat_view:category_param}}">{{category_name}}</router-link> > Fita <span class="text-txt-gray">事務用チェア Fita GR（肘なし）</span></p>-->
            </section>
        </div>
    </div>
    <Footer></Footer>
</template>
<script>
import CategoryList from '@/components/CategoryList.vue';
import Footer from '@/components/Footer.vue';
import Carousel from '@/components/Carousel.vue';
import CarouselSlide from '@/components/CarouselSlide.vue';
import SoldOut from '@/components/kanbai.vue';
import SoldOutRow from '@/components/KanbaiRow.vue';
import Modal from '@/components/Modal.vue';
import { useRoute } from 'vue-router'
import { ref, watchEffect, reactive, defineComponent } from 'vue';
import axios from 'axios'
import { search_json } from '@/json.config.js';


export default defineComponent({
    components: {
        CategoryList,
        Footer,
        Carousel,
        CarouselSlide,
        Modal,
        SoldOut,
        SoldOutRow
    },
    methods: {
        handleClick: function () {
            window.scroll({ top: 0, behavior: 'smooth' });
        }
    },

    name: 'productview',


    setup() {
        const route = useRoute()
        const category_param = ref(route.query.webcat_view)
        const group_id = ref(route.query.cassette_id)
        const ichioshi_product_code = ref(route.query.ichioshi_product_code)
        const cassette_block_id = ref('')
        let url = ref('')
        const img_path = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/img/500/";
        const img_common_path = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/img/common/"
        const icon_nouki_tori = "icon_nouki_tori.png"
        const icon_nouki_3 = "icon_nouki_3.png"
        const common_icon_fab03 = "common_icon_fab03.png"
        const common_icon_fab01 = "common_icon_fab01.png"
        const common_icon_fab02 = "common_icon_fab02.png"
        const common_icon_fab07 = "common_icon_fab07.png"
        const common_icon_green = "common_icon_green.png"
        const common_icon_gpn = "common_icon_gpn.png"
        const common_icon_ecomark = "common_icon_ecomark.png"

        // const search_json = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/json/search.json"
        const group_items = ref([])
        const product_items = ref([])
        const item_imgs = ref([])

        let category_name = ref('')
        watchEffect(() => {
            category_param.value = route.query.webcat_view
            group_id.value = route.query.cassette_id

            // クエリパラメーターからカテゴリ名を作成
            switch (category_param.value) {
                case 'Outlet':
                    category_name.value = 'アウトレット'
                    break
                // case 'Prevention':
                //     category_name.value = '感染対策用品'
                //     break
                case 'Accessory':
                    category_name.value = 'アクセサリー'
                    break
                case 'Desk':
                    category_name.value = 'デスク・デスク周辺'
                    break
                case 'Table':
                    category_name.value = 'テーブル'
                    break
                case 'Chair':
                    category_name.value = 'チェア'
                    break
                case 'Lobby':
                    category_name.value = '応接・ロビー'
                    break
                case 'MeetingChair':
                    category_name.value = 'ミーティングチェア'
                    break
                case 'Partition':
                    category_name.value = 'パーティション'
                    break
                case 'Board':
                    category_name.value = 'ボード'
                    break
                case 'Storage':
                    category_name.value = '収納'
                    break
                case 'Counter':
                    category_name.value = 'カウンター'
                    break
                // case 'Emergency':
                //     category_name.value = '防災用品'
                //     break
                case 'Education':
                    category_name.value = '教育・保育施設'
                    break
                case 'Medical':
                    category_name.value = '医療・福祉施設'
                    break
                default:
                    category_name.value = ''
                    break
            }
        })

        cassette_block_id.value = group_id.value.split("_")[0]

        const viewItem = ref({
            product_name: '',
            maker_name: '',
            ichioshi_product_code: '',
            Product_number: '',
            deadline: '',
            deadline_mark: '',
            icon_green: '',
            icon_gpn: '',
            icon_eco: '',
            listprice_maker_off: '',
            listprice_maker_on: '',
            price_off: '',
            price_on: '',
            nomal_off: '',
            web_img01: '',
            web_img02: '',
            web_img03: '',
            web_img04: '',
            product_catch: '',
            product_spec: '',
            Individual_comment01: '',
            Individual_comment02: '',
            movie_url01: '',
            movie_url02: '',
            outlet_stock: '',
            sold_out_labels: '',
            cassette_block_name: '',
            b_body_arr_len: null
        })



        // グループテーブル表示用変数
        let url_02 = ref('');

        const state = reactive({
            data: null,
            items: null,
            cassette_block: null,
            product_name: null,
            maker_name: null,
            cassette_comment01: null,
            cassette_comment02: null,
            cassette_comment03: null,
            cassette_img01: null,
            cassette_img02: null,
            cassette_img03: null,
            cassette_img04: null,
            b_body_arr: null
        })

        watchEffect(() => {
            url = "https://666wcb198b.execute-api.ap-northeast-1.amazonaws.com/resource/query?operationtype=product&webcat_view=" + category_param.value + "&cassette_id=" + group_id.value + "&ichioshi_product_code=" + ichioshi_product_code.value;
            url_02 = "https://666wcb198b.execute-api.ap-northeast-1.amazonaws.com/resource/query?operationtype=product&webcat_view=" + category_param.value + "&cassette_id=" + cassette_block_id.value;


            group_items.value = []
            product_items.value = []
            item_imgs.value = []
            ichioshi_product_code.value = route.query.ichioshi_product_code

            async function getitems() {
                const all_data = await axios.get(search_json)
                const c_i_block_name = [];//add0818
                // console.log(all_data)
                all_data.data.forEach(function (value) {
                    if (value.ichioshi_product_code === ichioshi_product_code.value) {
                        product_items.value.push(value)
                    }
                })

                // viewItem.value.data = await axios.get(url)
                viewItem.value.items = product_items.value
                // console.log(viewItem.value.items)
                // console.log(viewItem.value.items[0])

                viewItem.value.product_name = viewItem.value.items[0].product_name
                viewItem.value.maker_name = viewItem.value.items[0].maker_name
                viewItem.value.ichioshi_product_code = viewItem.value.items[0].ichioshi_product_code
                viewItem.value.Product_number = viewItem.value.items[0].Product_number
                viewItem.value.deadline = viewItem.value.items[0].deadline
                viewItem.value.deadline_mark = viewItem.value.items[0].deadline_mark
                viewItem.value.icon_green = viewItem.value.items[0].icon_green
                viewItem.value.icon_gpn = viewItem.value.items[0].icon_gpn
                viewItem.value.icon_eco = viewItem.value.items[0].icon_eco
                viewItem.value.listprice_maker_off = Number(viewItem.value.items[0].listprice_maker_off)
                viewItem.value.listprice_maker_off = viewItem.value.listprice_maker_off.toLocaleString()
                viewItem.value.listprice_maker_on = Number(viewItem.value.items[0].listprice_maker_on)
                viewItem.value.listprice_maker_on = viewItem.value.listprice_maker_on.toLocaleString()
                viewItem.value.price_off = Number(viewItem.value.items[0].price_off)
                viewItem.value.price_off = viewItem.value.price_off.toLocaleString()
                viewItem.value.price_on = Number(viewItem.value.items[0].price_on)
                viewItem.value.price_on = viewItem.value.price_on.toLocaleString()
                viewItem.value.nomal_off = viewItem.value.items[0].nomal_off
                // viewItem.value.nomal_off = Number(viewItem.value.nomal_off)*100
                viewItem.value.web_img01 = viewItem.value.items[0].web_img01
                viewItem.value.web_img02 = viewItem.value.items[0].web_img02
                viewItem.value.web_img03 = viewItem.value.items[0].web_img03
                viewItem.value.web_img04 = viewItem.value.items[0].web_img04
                viewItem.value.product_catch = viewItem.value.items[0].product_catch
                viewItem.value.product_spec = viewItem.value.items[0].product_spec
                viewItem.value.Individual_comment01 = viewItem.value.items[0].Individual_comment01
                viewItem.value.Individual_comment02 = viewItem.value.items[0].Individual_comment02
                viewItem.value.movie_url01 = viewItem.value.items[0].movie_url01
                viewItem.value.movie_url02 = viewItem.value.items[0].movie_url02
                viewItem.value.outlet_stock = viewItem.value.items[0].outlet_stock
                viewItem.value.sold_out_labels = viewItem.value.items[0].sold_out_labels
                viewItem.value.cassette_block_name = viewItem.value.items[0].cassette_block_name

                // グループテーブル表示用
                const all_data_2 = await axios.get(search_json)
                // console.log(all_data)
                all_data_2.data.forEach(function (value) {
                    if (value.webcat_view === category_param.value && value.cassette_id === group_id.value) {
                        group_items.value.push(value)
                        c_i_block_name.push(value.cassette_included_block_name);//add0818
                    }
                })

                state.items = group_items.value
                console.log(state.items);
                state.b_body_arr_len = state.items.length;



                state.cassette_id = state.items[0].cassette_id
                state.webcat_view = state.items[0].webcat_view
                state.cassette_block_name = state.items[0].cassette_block_name
                state.product_name = state.items[0].product_name;
                state.maker_name = state.items[0].maker_name;
                state.cassette_comment01 = state.items[0].cassette_comment01;
                state.cassette_comment02 = state.items[0].cassette_comment02;
                state.cassette_comment03 = state.items[0].cassette_comment03;
                state.cassette_img01 = img_path + state.items[0].cassette_img01;
                state.cassette_img02 = img_path + state.items[0].cassette_img02;
                state.cassette_img03 = img_path + state.items[0].cassette_img03;
                state.cassette_img04 = img_path + state.items[0].cassette_img04;
                state.maker_name = state.items[0].maker_name;
                state.sold_out_cd = state.items[0].sold_out_cd;
                //タイトル変更
                document.title = viewItem.value.product_name + "｜イチオシ";


                //ページ下部のグループ一覧を作る add0818
                //cassette_included_block_nameの重複排除しリスト化
                // console.log(c_i_block_name);
                const set = new Set(c_i_block_name);
                const c_i_block_nameArr = [...set];
                // console.log(c_i_block_nameArr)

                // 同じcassette_included_block_name
                let bottomHTML = []
                let all_bottomHTML = []

                for (let i = 0; i < c_i_block_nameArr.length; i++) {
                    bottomHTML = []
                    // console.log(c_i_block_nameArr[i])
                    state.items.filter(value => {
                        // console.log(value.cassette_included_block_name)
                        if (value.cassette_included_block_name.indexOf(c_i_block_nameArr[i]) !== -1) {
                            bottomHTML.push(value)
                        }
                    });
                    all_bottomHTML.push({ key_title: c_i_block_nameArr[i], key_body: bottomHTML })
                }

                // console.dir(value.cassette_included_block_name)
                // console.dir(all_bottomHTML);
                // group_items.value.forEach(function(value) {
                //     // group_items.value.push(value)
                // })
                state.b_body_arr = all_bottomHTML
            }
            // const getItem = getitems()
            getitems()


            async function changeimg() {
                // const api = await axios.get(url)

                // if(api.data.Items[0].web_img01 != ' '){
                //     slides.value[0] = img_path+api.data.Items[0].web_img01
                // }
                // if(api.data.Items[0].web_img02 != ' '){
                //     slides.value[1] = img_path+api.data.Items[0].web_img02
                // }
                // if(api.data.Items[0].web_img03 != ' '){
                //     slides.value[2] = img_path+api.data.Items[0].web_img03
                // }
                // if(api.data.Items[0].web_img04 != ' '){
                //     slides.value[3] = img_path+api.data.Items[0].web_img04
                // }

                const api = await axios.get(search_json)
                api.data.forEach(function (value) {
                    if (value.ichioshi_product_code === ichioshi_product_code.value) {
                        item_imgs.value.push(value)
                    }
                })

                if (item_imgs.value[0].web_img01 != ' ') {
                    slides.value[0] = img_path + item_imgs.value[0].web_img01
                }
                if (item_imgs.value[0].web_img02 != ' ') {
                    slides.value[1] = img_path + item_imgs.value[0].web_img02
                }
                if (item_imgs.value[0].web_img03 != ' ') {
                    slides.value[2] = img_path + item_imgs.value[0].web_img03
                }
                if (item_imgs.value[0].web_img04 != ' ') {
                    slides.value[3] = img_path + item_imgs.value[0].web_img04
                }
            }
            changeimg()



        })

        const slides = ref([])

        async function getimg() {
            // slides.value.data = await axios.get(url)
            const api = await axios.get(search_json)
            api.data.forEach(function (value) {
                if (value.ichioshi_product_code === ichioshi_product_code.value) {
                    item_imgs.value.push(value)
                }
            })
            // console.log(item_imgs.value[0].web_img01)

            if (item_imgs.value[0].web_img01 != ' ') {
                slides.value.push(img_path + item_imgs.value[0].web_img01)
            }
            if (item_imgs.value[0].web_img02 != ' ') {
                slides.value.push(img_path + item_imgs.value[0].web_img02)
            }
            if (item_imgs.value[0].web_img03 != ' ') {
                slides.value.push(img_path + item_imgs.value[0].web_img03)
            }
            if (item_imgs.value[0].web_img04 != ' ') {
                slides.value.push(img_path + item_imgs.value[0].web_img04)
            }

        }
        // console.log(slides.value)

        const getImg = getimg()

        const visibleSlide = ref(0)

        const mo_img_01 = () => {
            visibleSlide.value = 0
        }
        const mo_img_02 = () => {
            visibleSlide.value = 1
        }
        const mo_img_03 = () => {
            visibleSlide.value = 2
        }
        const mo_img_04 = () => {
            visibleSlide.value = 3
        }



        // 画像クリックでモーダル表示
        const showContent = ref()
        const imgFlag = ref()
        const openModal = (index) => {
            showContent.value = true
            // console.log(index)
            imgFlag.value = index
        }

        const closeModal = () => {
            showContent.value = false
        }



        return {
            category_param,
            category_name,
            group_id,
            cassette_block_id,
            watchEffect,
            img_path,
            img_common_path,
            //  getItem,
            viewItem,
            slides,
            visibleSlide,
            getImg,
            mo_img_01,
            mo_img_02,
            mo_img_03,
            mo_img_04,
            openModal,
            closeModal,
            showContent,
            imgFlag,
            state,
            url,
            url_02,
            icon_nouki_tori,
            icon_nouki_3,
            common_icon_fab03,
            common_icon_fab01,
            common_icon_fab02,
            common_icon_fab07,
            common_icon_green,
            common_icon_gpn,
            common_icon_ecomark
        }
    }
})


//ページ下部のリンククリックでページTOPに移動する
// let elem = document.getElementsByClassName('router-link-active');
// let elem = document.getElementsById('bottom_list');
// elem.addEventListener('click', scroll_to_top);


</script>